var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmsWysiwyg"},[(!_vm.isSlot)?_c('div',{staticClass:"cmsWysiwyg__block wysiwyg",class:`${_vm.additionalClasses} wysiwyg--${_vm.className}`,domProps:{"innerHTML":_vm._s(_vm.cleanHtml)}}):_c('div',{staticClass:"cmsWysiwyg__block wysiwyg",class:`${_vm.additionalClasses} wysiwyg--${_vm.className}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }